import { call, put, select } from 'redux-saga/effects';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import {
  sdkMobileStopScreenshareRequested,
  sdkMobileStartScreenshareRequested,
} from 'features/sdk/actions';
import { notification } from 'features/notifications/toast/notification';
import { selectLocalScreenshareBroadcasting } from 'features/streaming/streamingSlice';
import i18n from 'i18n';

export function* mobileScreenshareToggledSaga() {
  const allowScreenshare: boolean = yield call(hasPermissionsSaga, PermissionTypes.screenshare);

  if (allowScreenshare) {
    const isBroadcasting: boolean = yield select(selectLocalScreenshareBroadcasting);

    if (!isBroadcasting) {
      yield put(sdkMobileStartScreenshareRequested());
    } else {
      yield put(sdkMobileStopScreenshareRequested());
    }
  } else {
    yield put(sdkMobileStopScreenshareRequested());
    yield call(notification, i18n.t('notifications:screenshare_no_permissions'));
  }
}
